require("../coord/cartesian/AxisModel");

require("./axis/CartesianAxisView");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/axis.js
// module id = zz1u
// module chunks = 0 1